const SeoContentSection = () => {
  return (
    <section className="container px-4 md:px-6 py-16 max-w-4xl mx-auto">
      <h2 className="text-2xl md:text-3xl font-bold mb-6">
        The Smarter Way to Find Your Next Ride
      </h2>
      <div className="space-y-4 text-muted-foreground leading-relaxed">
        <p>
          DemoStoke is the surfboard demo marketplace built for surfers who want
          to try before they buy. Browse shortboards, longboards, fish, and
          mid-lengths from local surf shops, indie shapers, and fellow surfers —
          then ride them in the waves you actually surf. Snowboards, skis, and
          mountain bikes are here too.
        </p>
        <p>
          Whether you're hunting for a new daily driver shortboard in Venice
          Beach, a longboard for a week on the North Shore, or a step-up for a
          Central America trip, DemoStoke connects you with real boards from real
          people near the break. Skiers and mountain bikers can demo the same
          way. No more guessing whether a board will work based on specs alone.
        </p>
        <p>
          For shops and gear owners, DemoStoke is a free platform to get your
          rental and demo inventory discovered online. We handle the listing,
          search optimization, and booking — you focus on keeping riders stoked.
        </p>
      </div>
    </section>
  );
};

export default SeoContentSection;
